//
//
//
//
//
//
//
//
//
//
//

import VConsole from 'vconsole'
//
export default {
  name: 'ConsoleButton',
  /*----------------------------------------- 生命周期 -----------------------------------------*/
  created() {
    // 根据环境，加载vConsole
    if (process.env.NODE_ENV !== 'production') {
      this.createVConsole()
    }
    console.log('当前环境是', process.env.NODE_ENV)
  },
  methods: {
    /*----------------------------------------- 自定义方法 -----------------------------------------*/


    /*----------------------------------------- 绑定方法 -----------------------------------------*/
    /**
     * 打开vConsole点击
     */
    createVConsole() {
      window.vConsole = new VConsole()
    }
  }
}



// WEBPACK FOOTER //
// ./src/items/DebugBlock/ConsoleButton.vue